/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class ChecklistStepImage {
  id: number;
  mediaId: number;
  location: string;
  description: string;
}
